import _ from "lodash";
import { useContext, useEffect, useState } from "react";
import ConfigurationViewPage from "../../../components/management/PartnerGenericConfigurationPages/ConfigurationViewPage";
import { GlobalConfigContext } from "../../../context/GlobalConfigContext";
import { paths } from "../../../routes/paths";
import "./GenericConfigurationViewPage.scss";

export default function GenericConfigurationViewPage() {
  const [configData, setConfigData] = useState({
    administrator_destination_email: "",
  });
  const { programConfigurations } = useContext(GlobalConfigContext);

  const configKey = "generic_configuration";
  const editPath = `/${paths.system_setting}/${paths.generic_configuration}/edit`;

  useEffect(() => {
    const configuration = _.find(programConfigurations, {
      key: configKey,
    });
    if (configuration !== null && configuration !== undefined) {
      setConfigData(configuration.value?.data);
    }
  }, [programConfigurations]);

  const breadcrumbPath = [
    {
      href: "/",
      label: "Home",
    },
    {
      label: "Program Settings",
      href: `../../../${paths.system_setting}`,
    },
    {
      label: "Generic Configuration View",
      href: `../../../${paths.system_setting}/${paths.generic_configuration}`,
    },
  ];

  return (
    <ConfigurationViewPage
      configKey={configKey}
      headerText="Generic Configuration View"
      description="General configuration for the portal."
      breadcrumbPath={breadcrumbPath}
      editPath={editPath}
    >
      <h5 className="$color-text-primary">
        Administrator Destination Email:{" "}
        <span className="value">
          {configData["administrator_destination_email"]}
        </span>
      </h5>
      <h5 className="$color-text-primary">
        Points Expiration in Days:{" "}
        <span className="value">{configData["points_expiration_in_days"]}</span>
      </h5>
      <h5 className="$color-text-primary">
        WhatsApp Contact Link:{" "}
        <span className="value">{configData["whatsapp_contact_link"]}</span>
      </h5>
    </ConfigurationViewPage>
  );
}
